import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import storage from "../nativeStorage";

const DEFAULT_SUBJECT = "New Features";

export default function SuperAdminMailMerge() {
  const navigate = useNavigate();
  const token = storage.getItem("token");
  const [recipients, setRecipients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [subject, setSubject] = useState(DEFAULT_SUBJECT);
  const [middleBody, setMiddleBody] = useState("");
  const [selected, setSelected] = useState({});
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
    if (!token) { navigate("/superadmin"); return; }
    axios.get("/api/auth/superadmin/mailmerge-recipients", { headers: { Authorization: "Bearer " + token } })
      .then(res => {
        setRecipients(res.data);
        // Select everyone with a real email by default.
        const init = {};
        res.data.forEach(r => { init[r.id] = !!r.email; });
        setSelected(init);
      })
      .catch(e => { if (e.response?.status === 403) navigate("/superadmin"); else setError(e.response?.data?.error || "Failed to load"); })
      .finally(() => setLoading(false));
  }, []);

  const toggle = (id) => setSelected(s => ({ ...s, [id]: !s[id] }));
  const selectAll = (val) => {
    const next = {};
    recipients.forEach(r => { next[r.id] = val && !!r.email; });
    setSelected(next);
  };

  const recipientIds = recipients.filter(r => selected[r.id]).map(r => r.id);
  const noEmailCount = recipients.filter(r => !r.email).length;

  const send = async () => {
    if (!middleBody.trim()) { alert("Write the message body first"); return; }
    if (!recipientIds.length) { alert("Select at least one recipient"); return; }
    if (!window.confirm(`Send this email to ${recipientIds.length} registered account(s)? This cannot be undone.`)) return;
    setSending(true);
    setResult(null);
    try {
      const res = await axios.post("/api/auth/superadmin/mailmerge-send",
        { subject, middleBody, societyIds: recipientIds },
        { headers: { Authorization: "Bearer " + token } });
      setResult(res.data);
    } catch (e) {
      setResult({ error: e.response?.data?.error || "Network error" });
    }
    setSending(false);
  };

  return (
    <div style={{ minHeight: "100vh", background: "#1e1b4b" }}>
      <div style={{ background: "#312e81", padding: "14px 24px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <span style={{ fontSize: "22px" }}>📧</span>
          <div>
            <div style={{ color: "white", fontWeight: "800", fontSize: "15px" }}>Mail Merge — Registered Users</div>
            <div style={{ color: "#a5b4fc", fontSize: "11px" }}>Golf Society Manager — Triton42</div>
          </div>
        </div>
        <button onClick={() => navigate("/superadmin/dashboard")}
          style={{ background: "#4f46e5", color: "white", border: "none", borderRadius: "6px", padding: "6px 14px", fontSize: "12px", fontWeight: "700", cursor: "pointer" }}>
          ← Dashboard
        </button>
      </div>

      <div style={{ padding: "24px", maxWidth: "1100px", margin: "0 auto" }}>
        <div style={{ marginBottom: "16px" }}>
          <label style={{ ...labelStyle, color: "#a5b4fc" }}>Mailing List</label>
          <select disabled value="registered_users"
            style={{ width: "100%", maxWidth: "320px", border: "1px solid #4f46e5", background: "#312e81", color: "white", borderRadius: "8px", padding: "10px 12px", fontSize: "14px" }}>
            <option value="registered_users">Registered Users ({recipients.length} accounts)</option>
          </select>
          <div style={{ color: "#6b7280", fontSize: "11px", marginTop: "4px" }}>
            Every registered GSM club/society account. Member mail merges (a society's own players) stay in that society's own Mail Merge page.
          </div>
        </div>

        {error && <div style={{ background: "#fef2f2", color: "#b91c1c", padding: "10px 14px", borderRadius: "8px", fontSize: "13px", marginBottom: "16px" }}>{error}</div>}

        {loading ? (
          <div style={{ color: "#a5b4fc", textAlign: "center", padding: "40px" }}>Loading...</div>
        ) : (
          <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
            <div style={{ flex: "1 1 420px", minWidth: 320 }}>
              <label style={labelStyle}>Subject</label>
              <input value={subject} onChange={e => setSubject(e.target.value)} style={inputStyle} />

              <div style={{ marginTop: "18px", background: "#312e81", border: "1px solid #4f46e5", borderRadius: "10px", padding: "16px" }}>
                <div style={{ color: "#a5b4fc", fontSize: "13px", fontWeight: "700", marginBottom: "8px" }}>Hi GSM User,</div>
                <textarea value={middleBody} onChange={e => setMiddleBody(e.target.value)} rows={10}
                  placeholder="Write the announcement here..."
                  style={{ width: "100%", border: "1px solid #4f46e5", background: "#1e1b4b", color: "white", borderRadius: "8px", padding: "10px 12px", fontSize: "14px", boxSizing: "border-box", fontFamily: "inherit" }} />
                <div style={{ color: "#a5b4fc", fontSize: "13px", fontWeight: "700", marginTop: "8px" }}>Thanks,<br />GSM Support</div>
              </div>

              <div style={{ marginTop: "20px", background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "10px", padding: "14px" }}>
                <div style={{ fontSize: "12px", fontWeight: "700", color: "#6b7280", marginBottom: "8px" }}>PREVIEW</div>
                <div style={{ fontWeight: "700", marginBottom: "6px", color: "#111827" }}>{subject}</div>
                <div style={{ fontSize: "14px", lineHeight: 1.6, color: "#111827" }}>
                  Hi GSM User,<br /><br />
                  {middleBody.split("\n").map((line, i) => <React.Fragment key={i}>{line}<br /></React.Fragment>)}
                  <br />Thanks,<br />GSM Support
                </div>
              </div>
            </div>

            <div style={{ flex: "1 1 280px", minWidth: 260 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                <label style={{ ...labelStyle, marginTop: 0 }}>Recipients ({recipients.length}) · {recipientIds.length} selected</label>
                <div>
                  <button onClick={() => selectAll(true)} style={smallBtnStyle}>All</button>
                  <button onClick={() => selectAll(false)} style={smallBtnStyle}>None</button>
                </div>
              </div>
              <div style={{ maxHeight: "460px", overflowY: "auto", border: "1px solid #4f46e5", borderRadius: "10px" }}>
                {recipients.map(r => {
                  const hasEmail = !!r.email;
                  return (
                    <label key={r.id} style={{ display: "flex", alignItems: "center", gap: "8px", padding: "8px 10px", borderBottom: "1px solid #4338ca", fontSize: "13px", opacity: hasEmail ? 1 : 0.5 }}>
                      <input type="checkbox" checked={!!selected[r.id]} disabled={!hasEmail} onChange={() => toggle(r.id)} />
                      <span style={{ flex: 1, color: "white" }}>{r.name}</span>
                      <span style={{ fontSize: "10px", fontWeight: 700, color: r.account_type === "club" ? "#60a5fa" : "#a5b4fc" }}>
                        {r.account_type === "club" ? "CLUB" : "SOCIETY"}
                      </span>
                    </label>
                  );
                })}
              </div>

              {noEmailCount > 0 && (
                <div style={{ marginTop: "12px", fontSize: "12px", color: "#fcd34d" }}>
                  {noEmailCount} account{noEmailCount === 1 ? "" : "s"} above {noEmailCount === 1 ? "has" : "have"} no email on file and can't be selected.
                </div>
              )}

              <button onClick={send} disabled={sending || !recipientIds.length || !middleBody.trim()}
                style={{ marginTop: "16px", width: "100%", background: "#16a34a", color: "white", border: "none", borderRadius: "8px", padding: "12px", fontSize: "15px", fontWeight: "700", cursor: sending ? "default" : "pointer", opacity: (sending || !recipientIds.length || !middleBody.trim()) ? 0.6 : 1 }}>
                {sending ? "Sending..." : `Send to ${recipientIds.length} account(s)`}
              </button>

              {result && (
                <div style={{ marginTop: "12px", fontSize: "13px" }}>
                  {result.error && <div style={{ color: "#f87171" }}>{result.error}</div>}
                  {result.sent && <div style={{ color: "#4ade80" }}>Sent: {result.sent.length}</div>}
                  {result.skipped && result.skipped.length > 0 && <div style={{ color: "#f87171" }}>Skipped: {result.skipped.join(", ")}</div>}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const labelStyle = { display: "block", fontSize: "12px", fontWeight: "700", color: "#374151", marginTop: "14px", marginBottom: "4px" };
const inputStyle = { width: "100%", border: "1px solid #d1d5db", borderRadius: "8px", padding: "10px 12px", fontSize: "14px", boxSizing: "border-box" };
const smallBtnStyle = { fontSize: "11px", border: "1px solid #4f46e5", background: "#312e81", color: "white", borderRadius: "6px", padding: "3px 8px", marginLeft: "4px", cursor: "pointer" };
